import { Archive, BarChart, Home, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, ManageAccounts, PeopleAlt, Tune, Update, Workspaces } from "@mui/icons-material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { GetLastUrlPathLocalStorage } from "../../pages/PublicLayout/RedirectManager";
import { ContentbarProps, ISelectList } from "../Contentbar/ContentSide/ContentSideComp";
import { CurrentPage } from "../Contentbar/ContentSide/ContentSideList";
import { IUseContentBarAdminParameters } from "./sidebar";


export const useContentBarAdmin = ({
    isCollapsed,
    nameOrg,
   setIsCollapsed,
   navigateHome,
}: IUseContentBarAdminParameters) => {
    
    const navigate = useNavigate();

    function navigateRegularPage() {
        var lastUrlPath = GetLastUrlPathLocalStorage();
        if (lastUrlPath){
            navigate(lastUrlPath);
        } else {
            navigateHome();
        }
    }

    const contentBar: ContentbarProps<ISelectList>[] = [
        {
            children: t("Sidebar.Home"),
            isSelect: false,
            footer: false,
            icon: <Home />,
            isCollapsed: isCollapsed,
            onClick: (e) => navigate(`/${nameOrg}/adminConsole`),
            title: t("Sidebar.Home"),
            isSelectField: false,
            nameOrg: nameOrg!,
            disabled: false,
            renderOption: true,
            currentPage: CurrentPage.ADMIN,
        },
        
            {
              children: t("Sidebar.Dashboard"),
              isSelect: false,
              footer: false,
              icon: <BarChart/>,
              isCollapsed: isCollapsed,
              onClick: (e) => navigate(`/${nameOrg}/adminConsole/dashboard`),
              title: t("Sidebar.Dashboard"),
              isSelectField: false,
              disabled: false,
              renderOption: true,
              isNameOption: false,
              currentPage: CurrentPage.DASHBOARD,
        
            },
        {
            children: t("AdminConsole.AccountAndSubscription"),
            isSelect: false,
            footer: false,
            icon: <ManageAccounts />,
            isCollapsed: isCollapsed,
            onClick: () => navigate(`/${nameOrg}/adminConsole/accountAndSubscription`),
            title: t("AdminConsole.AccountAndSubscription"),
            isSelectField: false,
            disabled: false,
            renderOption: true,
            currentPage: CurrentPage.ACCOUNTANDSUBSCRIPTION,

        },
        {
            children: t("AdminConsole.UsersAndGroups"),
            isSelect: false,
            footer: false,
            icon: <PeopleAlt />,
            isCollapsed: isCollapsed,
            onClick: () => navigate(`/${nameOrg}/adminConsole/usersAndGroups`),
            title: t("AdminConsole.UsersAndGroups"),
            isSelectField: false,
            disabled: false,
            renderOption: true,
            currentPage: CurrentPage.USERS_AND_GROUPS,
            isCurrentPage: true
        },
        {
            children: t("AdminConsole.Plans"),
            isSelect: false,
            footer: false,
            icon: <Archive />,
            isCollapsed: isCollapsed,
            onClick: () => navigate(`/${nameOrg}/adminConsole/plans`),
            title: t("AdminConsole.Plans"),
            isSelectField: false,
            disabled: false,
            renderOption: true,
            currentPage: CurrentPage.PLANS,
            isCurrentPage: true
        },
        {
            children: "Workspaces",
            isSelect: false,
            footer: false,
            icon: <Workspaces />,
            isCollapsed: isCollapsed,
            onClick: () => navigate(`/${nameOrg}/adminConsole/workspaces`),
            title: "Workspaces",
            isSelectField: false,
            disabled: false,
            renderOption: true,
            currentPage: CurrentPage.WORKSPACE,
        },
        {
            children: t("Sidebar.Preferences"),
            isSelect: false,
            footer: true,
            icon: <Tune />,
            isCollapsed: isCollapsed,
            onClick: (e) => navigate(`/${nameOrg}/adminConsole/config`),
            title: t("Sidebar.Preferences"),
            isSelectField: false,
            disabled: nameOrg == "",
            renderOption: true,
            isNameOption: false,
            currentPage: CurrentPage.PREFERENCES,
        },
        {
            children: t("AdminConsole.ReturnToAccount"),
            isSelect: false,
            footer: true,
            icon: <AccountCircle />,
            isCollapsed: isCollapsed,
            onClick: navigateRegularPage,
            title: t("AdminConsole.ReturnToAccount"),
            isSelectField: false,
            disabled: nameOrg == "",
            renderOption: true,
            currentPage: CurrentPage.NONE,
        },
        {
            children: t("Sidebar.CloseSidebar"),
            isSelect: false,
            footer: true,
            icon: isCollapsed ?<KeyboardDoubleArrowRight />  :<KeyboardDoubleArrowLeft />,
            isCollapsed: isCollapsed,
            onClick: () => {
                setIsCollapsed(!isCollapsed)
                localStorage.setItem("persistedCollapsedSidebar", String(!isCollapsed))
            },
            title: t("Sidebar.CloseSidebar"),
            isSelectField: false,
            disabled: false,
            renderOption: true,
            currentPage: CurrentPage.NONE,
        },
    ]

    return {
        contentBarAdmin: contentBar,
    }
}

